module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dialog) ? _c('div', {
    attrs: {
      "id": "hcp-switch-modal"
    }
  }, [_c('mu-dialog'), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('p', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.isHcpView ? 'Go to patient view' : 'Go to HCP view')
    }
  }), _vm._v(" "), (_vm.isHcpView) ? _c('p', [_vm._v("You're about to switch to the patient view of the website")]) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('p', [_vm._v("You're about to switch to the HCP view of the website")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions",
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flat-button', {
    staticClass: "action close",
    attrs: {
      "label": "Close",
      "color": "#0179d5"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action continue",
    attrs: {
      "label": "Continue",
      "color": "#0179d5"
    },
    on: {
      "click": function($event) {
        return _vm.doSwitch()
      }
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3733fc04","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HCP/SwitchProgram.vue
// module id = 3122
// module chunks = 1